<ng-container *ngIf="dataReady">
  <!-- Search Form -->
  <form 
    class="row align-items-start mb-0 w-100 gx-3" 
    [formGroup]="searchForm"  
    (ngSubmit)="onSubmit()"
  >
    <!-- All Sources Dropdown -->
    <div class="col-md-2 col-lg-2 d-flex align-items-start">
      <div class="dropdown w-100">
        <button 
          id="sourcesDropdown"
          class="btn btn-outline-secondary dropdown-toggle w-100 text-start" 
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
          title="{{ selectedSourcesNames }}"
        >
          <span class="dropdown-button-text text-truncate">
            {{ selectedSourcesNames }}
          </span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="sourcesDropdown">
          <li *ngFor="let item of dropdownItems; trackBy: trackByDropItem" class="dropdown-item">
            <!-- Sources (including pinned All Sources) -->
            <ng-container *ngIf="isSourceItem(item)">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="item.src.value === 'default' ? allSourcesState === 'checked' : item.src.selected"
                  [indeterminate]="item.src.value === 'default' && allSourcesState === 'indeterminate'"
                  [attr.aria-checked]="item.src.value === 'default'
                    ? (allSourcesState === 'indeterminate' ? 'mixed' : (allSourcesState === 'checked' ? 'true' : 'false'))
                    : (item.src.selected ? 'true' : 'false')"
                  (change)="onDropdownItemToggle(item)"
                  [id]="'source-' + item.src.value"
                />
                <label
                  class="form-check-label text-truncate"
                  [for]="'source-' + item.src.value"
                  [title]="item.label"
                >
                  {{ item.label }}
                </label>
              </div>
            </ng-container>

            <!-- Tags -->
            <ng-container *ngIf="isTagItem(item)">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="tagStates.get(item.tagValue) === 'checked'"
                  [indeterminate]="tagStates.get(item.tagValue) === 'indeterminate'"
                  [attr.aria-checked]="tagStates.get(item.tagValue) === 'indeterminate' ? 'mixed' : (tagStates.get(item.tagValue) === 'checked' ? 'true' : 'false')"
                  (change)="onDropdownItemToggle(item)"
                  [id]="'tag-' + item.tagValue"
                />
                <label
                  class="form-check-label text-truncate"
                  [for]="'tag-' + item.tagValue"
                  [title]="item.label"
                >
                    {{ item.label }}
                  <span class="ms-1 text-muted small" *ngIf="getTagCount(item.tagValue) as c">({{ c }})</span>
                </label>
              </div>
            </ng-container>
          </li>
        </ul>
      </div>
    </div>

    <!-- Query Input and Search Button -->
    <div class="col-md-9 col-lg-10 d-flex align-items-start p-0">
      <input 
        id="queryInput"
        type="text"
        class="form-control search-input flex-grow-1"
        formControlName="query" 
        [placeholder]="searchBarPlaceholder"
      />
      <button 
        type="submit" 
        class="btn btn-primary search-button ms-4 align-self-end" 
        [disabled]="isLoading || isRagLoading || isSearchButtonDisabled"
      >
        <span *ngIf="!isLoading">{{ searchButtonLabel }}</span>
        <div *ngIf="isLoading" class="spinner-border" role="status"></div>
      </button>
    </div>  

    <!-- Second Row: AI PROMPT, AI Instructions, and AI Response Toggle -->
    <div class="row mt-3 mb-0 align-items-center gx-3 flex-wrap" *ngIf="isAIProviderExists && isAIProviderLoaded">
      <!-- Same width/offset as the query row -->
      <div class="offset-md-2 col-md-9 col-lg-10 d-flex align-items-center">

        <!-- Conditionally render the prompts and AI instructions -->
        <ng-container *ngIf="promptsExists">
          <div class="d-flex align-items-center">
            <label for="promptsDropdown" class="prompts-label fw-bold me-2"> 
              AI PROMPT:
            </label>
            <div class="dropdown me-3">
              <button 
                class="btn btn-outline-secondary dropdown-toggle text-truncate text-start" 
                type="button" 
                id="promptsDropdown"
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                title="{{ selectedPromptName }}"
              >
                {{ selectedPromptName }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="promptsDropdown">
                <li *ngFor="let prompt of prompts">
                  <button 
                    class="dropdown-item d-flex justify-content-between align-items-center text-truncate" 
                    type="button" 
                    (click)="selectPrompt(prompt.value)" 
                    title="{{ prompt.name }}"
                    [ngClass]="{'selected': prompt.value === searchForm.get('selectedPrompt')?.value}" 
                    [disabled]="isLoading || !hasResults"
                  >
                    <span 
                      class="text-truncate" 
                      [ngClass]="{'default-source': prompt.value === defaultPromptValue}"
                    >
                      {{ prompt.name }}
                    </span>
                    <span 
                      *ngIf="prompt.value === searchForm.get('selectedPrompt')?.value" 
                      class="custom-checkmark"
                    ></span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <!-- AI Instructions Input -->
          <input 
            id="aiInstructionsInput"
            type="text"
            class="form-control ai-instructions-input"
            formControlName="ai_instructions"
            [placeholder]="aiInstructionsPlaceholder"
          />
        </ng-container>

        <!-- AI Response Toggle -->
        <div class="d-flex align-items-center ms-2">
          <div class="form-check form-switch custom-toggle">
            <input
              class="form-check-input"
              type="checkbox"
              id="aiResponseToggle"
              [checked]="checkedGenerateAiResponseControl?.value"
              (change)="toggleChange($event)"
              [disabled]="isLoading || !hasResults"
            />
            <label class="form-check-label ms-2" for="aiResponseToggle">
              {{ aiResponseLabel }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
